import React from 'react'
import Main from '../layouts/Main'
import StatisticCards from '../components/StatisticCards'
import RecentOrders from '../components/RecentOrders'

function Orders() {
    return (
        <Main>

            {/* Start::page-header */}
            <div className="d-flex align-items-center justify-content-between my-4 page-header-breadcrumb flex-wrap gap-2">
                <div>
                    <p className="fw-semibold fs-20 mb-0">Orders</p>
                </div>
            </div>
            {/* End::page-header */}
            {/* Start:: row-1 */}
            <div className="row">
                <div className="col-xxl-12">
                    <StatisticCards />
                </div>
            </div>
            {/* End:: row-1 */}
            {/* Start:: row-3 */}
            <div className="row">
                <div className="col-xxl-12">
                    <RecentOrders />
                </div>
            </div>
            {/* End:: row-3 */}


        </Main>

    )
}

export default Orders